export default "__VITE_ASSET__DThtsUai__"